export function easterDate(y: number) {
  const a = y % 19;
  const b = Math.floor(y / 100);
  const c = y % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(y, month - 1, day);
}

export function getHolidayDates(date: Date) {
  const year = date.getFullYear();
  const easter = easterDate(year);
  const goodFriday = new Date(easter);
  goodFriday.setDate(easter.getDate() - 2);
  const easterMonday = new Date(easter);
  easterMonday.setDate(easter.getDate() + 1);
  const ascension = new Date(easter);
  ascension.setDate(easter.getDate() + 39);
  const whitMonday = new Date(easter);
  whitMonday.setDate(easter.getDate() + 50);
  const movableHolidays = [goodFriday, easterMonday, ascension, whitMonday];
  const fixedHolidays = [
    { month: 0, day: 1 }, // New Years
    { month: 7, day: 1 }, // States Day
    { month: 11, day: 25 }, // Christmas
    { month: 11, day: 26 }, // St. Stephen’s Day
  ];

  const isMovableHoliday = movableHolidays.some((d) => d.getTime() === date.getTime());
  const isFixedHoliday = fixedHolidays.some(
    (h) => date.getDate() === h.day && date.getMonth() === h.month,
  );

  return isFixedHoliday || isMovableHoliday;
}
